const listeners = new Set<() => void>();

/** Ask the mounted app drawer to open. The phone start screen uses this so it
 * does not import the navigation itself. */
export function requestOpenPhoneNav() {
  for (const listener of listeners) listener();
}

export function subscribeOpenPhoneNav(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
